import { DefaultErrorBoundary } from '@/components/errors/DefaultErrorBoundary/DefaultErrorBoundary'
import { Layout } from '@/components/Layout'
import { Typography } from '@/components/Typography'
import { BrowserTitleKeys, useBrowserTitle } from '@/hooks/useBrowserTitle'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'
import styles from './styles.module.scss'

export function AuthLayout() {
  const currentYear = new Date().getFullYear().toString()
  const { t } = useTranslation()
  useBrowserTitle({ titleKey: BrowserTitleKeys.auth })

  return (
    <Layout className={styles.container}>
      <DefaultErrorBoundary context="AUTH-PAGES" showLink={false}>
        <Layout.Content className={styles.content}>
          <img src="/images/marqii.svg" />

          <Outlet />
        </Layout.Content>
      </DefaultErrorBoundary>

      <Layout.Footer className={styles.footer}>
        <Typography.Text type="secondary">
          {t('pages.auth.copyright', { currentYear })}
        </Typography.Text>
      </Layout.Footer>
    </Layout>
  )
}
